import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "Send daily random photos from an S3 bucket using AWS Lambda – CodeWithSwiz 25",
  "description": "An experiment that sends daily photos from an S3 bucket to an IoT device using AWS Lambda",
  "published": "2021-04-06T00:00:00.000Z",
  "content_upgrade": "ServerlessHandbook",
  "hero": "./img/screenshot-1617727317273.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`We did it! We finished the experiment from a few weeks ago and The Girl can stop making jokes that I stole her present 🎉`}</p>
    <lite-youtube {...{
      "videoid": "2TCJli7t3nE",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Here's the plan:`}</p>
    <ol>
      <li parentName="ol">{`Buy cute IoT gimmick for Valentine's Day ✅`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://swizec.com/blog/reverse-engineer-a-graphql-api-to-automate-love-notes-codewithswiz-24"
        }}>{`Reverse engineer its API`}</a>{` ✅`}</li>
      <li parentName="ol">{`Build serverless Lambda that sends a picture ✅👆`}</li>
      <li parentName="ol">{`Move secrets to secrets manager ⌛️`}</li>
      <li parentName="ol">{`Read photos from S3 ⌛️`}</li>
      <li parentName="ol">{`Send base64 encoded photos ⌛️`}</li>
      <li parentName="ol">{`Run daily ⌛️`}</li>
    </ol>
    <p>{`The Girl was getting upset with me `}{`[name|Friend]`}{`. Waiting for those last 3 steps since February while I focused on `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev"
      }}>{`Serverless Handbook`}</a>{`.`}</p>
    <p>{`She waits no more! It's live`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/dd06371e4109fa1a6aa05c2dae8a13c4/ddf4f/Lambda-triggered-on-a-daily-croneb418b.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "41.25560538116592%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'165\\'%20viewBox=\\'0%200%20400%20165\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M140%2034v9h17V26h-5l-8-1h-4v9M11%2099v8h17V90H11v9\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/dd06371e4109fa1a6aa05c2dae8a13c4/ca0a1/Lambda-triggered-on-a-daily-croneb418b.webp 223w", "/static/dd06371e4109fa1a6aa05c2dae8a13c4/75680/Lambda-triggered-on-a-daily-croneb418b.webp 445w", "/static/dd06371e4109fa1a6aa05c2dae8a13c4/8d1ba/Lambda-triggered-on-a-daily-croneb418b.webp 890w", "/static/dd06371e4109fa1a6aa05c2dae8a13c4/3838e/Lambda-triggered-on-a-daily-croneb418b.webp 1335w", "/static/dd06371e4109fa1a6aa05c2dae8a13c4/f4654/Lambda-triggered-on-a-daily-croneb418b.webp 1624w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/dd06371e4109fa1a6aa05c2dae8a13c4/e92b6/Lambda-triggered-on-a-daily-croneb418b.png 223w", "/static/dd06371e4109fa1a6aa05c2dae8a13c4/e66bf/Lambda-triggered-on-a-daily-croneb418b.png 445w", "/static/dd06371e4109fa1a6aa05c2dae8a13c4/4ef49/Lambda-triggered-on-a-daily-croneb418b.png 890w", "/static/dd06371e4109fa1a6aa05c2dae8a13c4/4e814/Lambda-triggered-on-a-daily-croneb418b.png 1335w", "/static/dd06371e4109fa1a6aa05c2dae8a13c4/ddf4f/Lambda-triggered-on-a-daily-croneb418b.png 1624w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/dd06371e4109fa1a6aa05c2dae8a13c4/4ef49/Lambda-triggered-on-a-daily-croneb418b.png",
                "alt": "Lambda triggered on a daily cron",
                "title": "Lambda triggered on a daily cron",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Lambda triggered on a daily cron`}</figcaption>{`
  `}</figure></p>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/lovebox-lambda"
      }}>{`see the full code on GitHub`}</a>{`. Here's what we built:`}</p>
    <ContentUpgrades.ServerlessHandbook />
    <h2 {...{
      "id": "secrets-in-secrets-manager"
    }}>{`Secrets in secrets manager`}</h2>
    <p>{`Never deploy code with secret API keys in the files. You `}<em parentName="p">{`will`}</em>{` get hacked and your data `}<em parentName="p">{`will`}</em>{` get leaked.`}</p>
    <p>{`And when we're talking anonymous strangers from the internet can send dick pics to your girl ... nu-uh. All identifying info and API tokens went into the AWS Secrets Manager.`}</p>
    <p>{`Accessed in code like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/secrets.ts

import { SecretsManager } from "aws-sdk";

const ssm = new SecretsManager({
  region: "us-east-1", // make sure this matches your region
});

export async function getBearerToken() {
  const secret = await ssm
    .getSecretValue({ SecretId: "loveboxBearerToken" })
    .promise();

  const { BEARER_TOKEN } = JSON.parse(secret?.SecretString || "");

  return BEARER_TOKEN;
}
`}</code></pre>
    <p>{`Grab the `}<inlineCode parentName="p">{`SecretsManager`}</inlineCode>{`, instantiate with our region, write helper function to grab the API token. It talks to secrets secrets manager, retrieves the `}<inlineCode parentName="p">{`loveboxBearerToken`}</inlineCode>{` secret, parses the JSON response and returns what we need.`}</p>
    <p>{`I added my other secrets later.`}</p>
    <p>{`And we remembered to give our Lambda permissions to read secrets:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`# serverless.yml
provider:
  # ...
  iamRoleStatements:
    - Effect: "Allow"
      Action:
        - "secretsmanager:GetSecretValue"
      Resource: "arn:aws:secretsmanager:\${self:provider.region}:*"
`}</code></pre>
    <p>{`Borrowed all this from the `}<a parentName="p" {...{
        "href": "https://serverlesshandbook.dev/handling-secrets/"
      }}>{`Serverless Handbook chapter on secrets`}</a>{`. No point in memorizing what you can look up 😇`}</p>
    <h3 {...{
      "id": "using-secrets-for-the-graphqlclient"
    }}>{`Using secrets for the GraphQLClient`}</h3>
    <p>{`We need the bearer token to authorize our GraphQL client with the API. Means we have to instantiate with an async function.`}</p>
    <p>{`But talking to SecretsManager is an API call itself and that could make our Lambda slow. The answer is memoization.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`let graphQLClient: null | GraphQLClient = null;

async function createGraphQLClient() {
  if (graphQLClient === null) {
    const token = await getBearerToken();

    graphQLClient = new GraphQLClient(
      "https://app-api.loveboxlove.com/v1/graphql",
      {
        headers: {
          Authorization: \`Bearer \${token}\`,
        },
      }
    );
  }

  return graphQLClient;
}
`}</code></pre>
    <p>{`We create a global variable `}<inlineCode parentName="p">{`graphQLClient`}</inlineCode>{`. When it's defined `}<inlineCode parentName="p">{`createGraphQLClient`}</inlineCode>{` returns the client, when it isn't it first instantiates our client after reading the token from secrets.`}</p>
    <p>{`This lets us skip the secrets call when our Lambda gets reused ✌️`}</p>
    <h2 {...{
      "id": "read-photos-from-s3"
    }}>{`Read photos from S3`}</h2>
    <p>{`Reading photos from S3 happens in two steps:`}</p>
    <ol>
      <li parentName="ol">{`Get list of photos in bucket`}</li>
      <li parentName="ol">{`Read random photo`}</li>
    </ol>
    <h3 {...{
      "id": "list-photos"
    }}>{`List photos`}</h3>
    <p>{`We start by giving our lambda permissions to read S3.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`# serverless.yml

provider:
  # ...
  iamRoleStatements:
    # ...
    - Effect: "Allow"
      Action:
        - "s3:listObjects"
      Resource: "arn:aws:s3:::lovebox-stash/*"
`}</code></pre>
    <p>{`Yes, the S3 bucket is called `}<inlineCode parentName="p">{`lovebox-stash`}</inlineCode>{`.`}</p>
    <p>{`Then we create a helper function that grabs a list of objects from S3. This part was uneventful, but we had to make sure it works.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/pictures.ts

import { S3 } from "aws-sdk";

const s3 = new S3({
  apiVersion: "2006-03-01",
});

async function listPictures() {
  const list = await s3
    .listObjects({
      Bucket: "lovebox-stash",
    })
    .promise();

  return list.Contents;
}
`}</code></pre>
    <p>{`Instantiate an S3 client, keep it shared between Lambda calls, make a request to S3 to list every object in the bucket.`}</p>
    <h3 {...{
      "id": "read-random-photo"
    }}>{`Read random photo`}</h3>
    <p>{`Grabbing a random photo is a matter of maths and fetching an S3 object. Like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/pictures.ts

export async function getPicture() {
  const pictures = await listPictures();

  if (pictures) {
    const randomPic = pictures[Math.floor(Math.random() * pictures.length)];

    if (randomPic.Key) {
      const imageData = await s3
        .getObject({
          Bucket: "lovebox-stash",
          Key: randomPic.Key,
        })
        .promise();

      return imageData;
    }
  }

  return null;
}
`}</code></pre>
    <p>{`Grab list of photos, pick at random, read data. Ifs help with error handling.`}</p>
    <h2 {...{
      "id": "send-base64-encoded-photos"
    }}>{`Send base64 encoded photos`}</h2>
    <p>{`The final `}<inlineCode parentName="p">{`sendPicture`}</inlineCode>{` function looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`async function sendPicture(picture: S3.GetObjectOutput) {
  const base64 = \`data:\${picture.ContentType};base64,\${picture.Body?.toString(
    "base64"
  )}\`;
  const client = await createGraphQLClient();
  const { recipient, deviceId } = await getRecipient();

  const res = await client.request(
    // query,
    {
      base64,
      recipient,
      contentType: ["Image"],
      options: {
        framesBase64: null,
        deviceId,
      },
    }
  );
  console.log(res);
}
`}</code></pre>
    <p>{`Get random photo, encode in `}<inlineCode parentName="p">{`base64`}</inlineCode>{`, add the mime type. Create authorized GraphQL client, get recipient secrets, send as variables to the GraphQL query.`}</p>
    <p>{`And you get a happy Swiz`}</p>
    <p><img parentName="p" {...{
        "src": "/71f1c1052882043012425e0d149eb0aa/Yay-the-hackery-works8if376.gif",
        "alt": "Yay the hackery works"
      }}></img></p>
    <h2 {...{
      "id": "run-daily"
    }}>{`Run daily`}</h2>
    <p>{`This part's easy 👉 add cron config to `}<inlineCode parentName="p">{`serverless.yml`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`# serverless.yml

functions:
    sendNote:
        handler: dist/lovebox.sendNote
        events:
            - schedule: rate(1 day)
`}</code></pre>
    <p>{`Run daily, at a time of your choosing.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: the `}<a parentName="p" {...{
        "href": "http://serverlesshandbook.dev/"
      }}>{`Serverless Handbook`}</a>{` paperback is now $36 on Amazon, not sure why but check it out if you're curious`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      